export enum RoleID {
  MEMBER = 2,
  PARENT = 4,
}
export enum Role {
  MEMBER = "นักเรียน",
  PARENT = "ผู้ปกครอง",
  MEMBER_EN = "student",
  PARENT_EN = "parent",
}

export const RoleObject = {
  MEMBER: {
    id: 2,
    name: "นักเรียน",
  },
  PARENT: {
    id: 4,
    name: "ผู้ปกครอง",
  },
};
